import { render, staticRenderFns } from "./UserLogsDetail.vue?vue&type=template&id=5ebcf598"
import script from "./UserLogsDetail.vue?vue&type=script&lang=js"
export * from "./UserLogsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports